import { create } from "zustand";

import { getClaims } from "../services/user";

const authChannel = new BroadcastChannel("auth-state");

type AuthState = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  user: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  session: any;
  loading: boolean;
  initialized: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setUser: (user: any) => void;
  fetchUser: () => Promise<void>;
  logout: () => Promise<void>;
};

export const useAuthStore = create<AuthState>()((set, get) => ({
  user: null,
  session: null,
  loading: true,
  initialized: false,

  setUser: (user) => {
    set({ user });
  },

  fetchUser: async () => {
    const { initialized, session } = get();
    if (initialized && session) return;

    set({ loading: true });

    try {
      const claimsData = await getClaims();

      if (!claimsData) {
        set({ user: null, session: null, loading: false, initialized: true });
        return;
      }

      // Extract user information from claims
      const user = {
        id: claimsData.sub,
        email: claimsData.email,
        phone: claimsData.phone,
        role: claimsData.role,
        app_metadata: claimsData.app_metadata ?? {},
        user_metadata: claimsData.user_metadata ?? {},
        aal: claimsData.aal,
        amr: claimsData.amr,
        session_id: claimsData.session_id,
        is_anonymous: claimsData.is_anonymous ?? false,
      };

      set({
        user: user,
        session: { user, access_token: null, refresh_token: null },
        loading: false,
        initialized: true,
      });
    } catch {
      set({ user: null, session: null, loading: false, initialized: true });
    }
  },

  syncLogout: () => {
    authChannel.postMessage({ type: "LOGOUT" });
    set({ user: null, session: null });
  },

  logout: async () => {
    // Clear the auth state
    await Promise.resolve(); // Satisfy the async requirement
    set({ user: null, session: null, initialized: true });

    // Note: Cookie clearing is now handled by the supabase client's signOut method
    // when called from components that have access to the supabase client
  },
}));

authChannel.addEventListener("message", (event) => {
  if (event.data.type === "LOGOUT") {
    void useAuthStore.getState().logout();
  }
});

// export const useAuthStore = create<AuthState>()(
//   persist(
//     (set, get) => ({
//       user: null,
//       session: null,
//       loading: true,
//       initialized: false,

//       setUser: (user) => {
//         set({ user });
//       },

//       fetchUser: async () => {
//         const { initialized, session } = get();
//         if (initialized && session) return;

//         set({ loading: true });

//         try {
//           const claimsData = await getClaims();

//           if (!claimsData) {
//             set({ user: null, session: null, loading: false, initialized: true });
//             return;
//           }

//           // Extract user information from claims
//           const user = {
//             id: claimsData.sub,
//             email: claimsData.email,
//             phone: claimsData.phone,
//             role: claimsData.role,
//             app_metadata: claimsData.app_metadata ?? {},
//             user_metadata: claimsData.user_metadata ?? {},
//             aal: claimsData.aal,
//             amr: claimsData.amr,
//             session_id: claimsData.session_id,
//             is_anonymous: claimsData.is_anonymous ?? false,
//           };

//           set({
//             user: user,
//             session: { user, access_token: null, refresh_token: null },
//             loading: false,
//             initialized: true,
//           });
//         } catch {
//           set({ user: null, session: null, loading: false, initialized: true });
//         }
//       },

//       logout: async () => {
//         // Clear the auth state
//         await Promise.resolve(); // Satisfy the async requirement
//         set({ user: null, session: null, initialized: true });

//         // Note: Cookie clearing is now handled by the supabase client's signOut method
//         // when called from components that have access to the supabase client
//       },
//     }),
//     { name: "auth" },
//   ),
// );
